/**
 * Account Service — account-level self-service operations.
 *
 * Mirrors billing.js: uses the shared `accountApi` client (auth header +
 * /account base path on the account RestApi, same host as /billing/*).
 *
 * deleteAccount() is DESTRUCTIVE — it permanently erases all of the caller's
 * account data on the backend. The UI gates it behind a typed-confirmation
 * modal; the backend independently requires { confirm: "DELETE" } and
 * owner-only auth.
 */
import { accountApi as apiService } from './api';

// Must match the backend's CONFIRM_TOKEN (handlers/account.js).
export const DELETE_CONFIRM_TOKEN = 'DELETE';

class AccountService {
  /**
   * DELETE /account — cascade-delete the caller's account.
   * @returns {Promise<{ deleted: boolean, accountId: string, summary: object }>}
   */
  async deleteAccount() {
    return apiService.delete('/account', {
      body: { confirm: DELETE_CONFIRM_TOKEN },
    });
  }
}

const accountService = new AccountService();
export default accountService;
